import _Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SmartLink from '@/components/nav/links/SmartLink.vue';

// A place to keep global components.
export const GlobalComponentsPlugin = {
	install(Vue: typeof _Vue) {
		Vue.component('FontAwesomeIcon', FontAwesomeIcon);

		// Register SmartLink globally so it can be used anywhere without importing
		Vue.component('SmartLink', SmartLink);
	},
};
